import { Link } from 'react-router-dom';
import notFound from '../../assets/404_notfound.svg';

export default function NotFound() {
  return (
    <div className="flex flex-col justify-between bg-[#fff]">
      <div className="flex flex-col items-center justify-center flex-grow pt-[88px] pb-[120px]">
        <div className="flex flex-col items-center">
          <img
            src={notFound}
            alt="404 Not Found"
            className="w-[334px] h-[162px] mb-16"
          />
          <h2 className="text-2xl font-semibold mt-2 mb-12 text-center">Sorry, no such evaluation was found</h2>
          <Link to="/" 
            className="inline-block mt-2 bg-[#111827] text-white rounded-md font-medium hover:bg-[#1e293b] transition"
            style={{ width: '270px', height: '36px', padding: '10px 48px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            Start New Evaluation
          </Link>
        </div>
      </div>
    </div>
  );
} 